import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from '../global/global.component';
import { SeoService } from '../service/seo.service';

@Component({
  selector: 'login-forvendor',
  templateUrl: './forvendor.component.html',
  styleUrls: ['./forvendor.component.scss']
})
export class ForvendorComponent implements OnInit {

  hostName = GlobalComponent.hostName;

  constructor(private SEOService:SeoService) { }

  ngOnInit(){

  this.SEOService.updateCanonicalUrl(this.hostName + '/vendors-benefits');


  }

}
